export enum DeployedEnv {
  UNKNOWN = 'unknown',
  LOCAL = 'local',
  DEV = 'dev',
  TEST = 'test',
  STAGE = 'stage',
  PROD = 'prod',
}

export type CommerceEnv = 'dev' | 'int' | 'uat' | 'prod'

export type EnvHostInfo = {
  commerceEnv: CommerceEnv
  [brand: string]: string
}

export type EnvApiKeyInfo = {
  commerceEnv: CommerceEnv
  keys: {
    [brand: string]: Record<string, string>
  }
}

export type FeatureConfig = {
  allowWCTokensWithoutSessionId?: boolean
  disableQuoteFreeShipping?: boolean
  disableStrictSSNValidation?: boolean
  disableAuthTokenSessionIdCheck?: boolean
  disableInsuranceMemberEligibilityCheck?: boolean
  disableInsuranceToggleMessages?: boolean
  validateInsurerEligibleProduct?: boolean
  contactUs?: ('phone' | 'chat' | 'faq' | 'email')[]
}

export type HostInfo = {
  apiHost: EnvHostInfo
  apiKey: EnvApiKeyInfo
  feature?: FeatureConfig
  env: DeployedEnv
}
